import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';

import CircularProgress from '@material-ui/core/CircularProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import { useSnackbar } from 'notistack';
import Loding from 'routes/partials/Loding';
const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
}));

const CountryAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [currency, setCurrency] = useState('');
  const [continent, setContinent] = useState('');
  const [phone, setPhone] = useState('');
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  console.log('editForm', editForm);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const clearStates = () => {
    setId('');
    setName('');
    setCode('');
    setCurrency('');
    setContinent('');
    setPhone('');
    setStatus(false);
    setEditObj({});
  };

  const validation = () => {
    let isError = false;
    if (!name.trim()) {
      console.log('name');
      handleSnakbarOpen('Please enter name', 'error');
      document.getElementById('name').focus();
      return (isError = true);
    }
    if (!code.trim()) {
      handleSnakbarOpen('Please enter code', 'error');
      document.getElementById('code').focus();
      return (isError = true);
    }
    if (!currency.trim()) {
      console.log('currency');
      handleSnakbarOpen('Please enter currency', 'error');
      document.getElementById('currency').focus();
      return (isError = true);
    }
    if (!continent.trim()) {
      console.log('continent');
      handleSnakbarOpen('Please enter continent', 'error');
      document.getElementById('continent').focus();
      return (isError = true);
    }
    if (!phone.trim()) {
      console.log('phone');
      handleSnakbarOpen('Please enter phone number', 'error');
      document.getElementById('phone').focus();
      return (isError = true);
    }
    console.log('finish');
    return isError;
  };

  const onSubmit = async e => {
    e.preventDefault();
    let err = validation();
    console.log('err', err);
    if (err) {
      return;
    } else {
      console.log('onSubmit');
      console.log('editIndexNo', editIndexNo);
      e.preventDefault();
      setLoading(true);
      let response;
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);
      try {
        if (addForm) {
          response = await axios({
            url: `/api/v1/private/countries`,
            method: 'post',
            data: { name, code, currency, continent, phone, status },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('addForm Submit', name, code, currency, continent, phone, status);
          setList([...list, response.data.data]);

          console.log('addForm response', response);
        } else if (editForm) {
          response = await axios({
            url: `/api/v1/private/countries/${id}`,
            method: 'put',
            data: { name, code, currency, continent, phone, status },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('editForm Submit', id, name, code, currency, continent, phone, status);
          console.log('editForm response', response);

          list[editIndexNo] = response.data.data;
          setRefresh(!refresh);
        }

        closeAddDialog();
        activeAddForm();
        handleSnakbarOpen(response.data.message, 'success');
      } catch (error) {
        console.log('error', error);
        console.log('errorresponse', error.response);

        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
        setLoading(false);
      }
      setLoading(false);
    }
    // handleSnakbarOpen()
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  useEffect(() => {
    console.log('loading edit data', editObj);

    if (editObj.id) {
      console.log('loading edit data 2');

      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setName(editObj.name);
      setCode(editObj.code);
      setCurrency(editObj.currency);
      setPhone(editObj.phone);
      setContinent(editObj.continent);
      setStatus(editObj.status);
    }
  }, [editObj]);

  const activeAddForm = () => {
    clearStates();
    // setEditForm(false);
    // setAddForm(true);
  };

  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);
  return (
    <React.Fragment>
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update Country' : 'Add Country'}
        </Typography>
      </div>

      <TextField
        id="name"
        label="Name"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={name}
        onChange={e => setName(e.target.value)}
      />
      <TextField
        id="code"
        label="Code"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={code}
        onChange={e => setCode(e.target.value)}
      />
      <TextField
        id="currency"
        label="Currency"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={currency}
        onChange={e => setCurrency(e.target.value)}
      />
      <TextField
        id="continent"
        label="Continent"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={continent}
        onChange={e => setContinent(e.target.value)}
      />
      <TextField
        id="phone"
        label="Phone"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={phone}
        onChange={e => {
          setPhone(e.target.value);
        }}
      />
      <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
        <FormControlLabel
          control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
          label="Status"
          labelPlacement="start"
        />
      </div>

      <div>{/* <Loding/> */}</div>
      <div className={classes.buttonMarginStyle}>
        {/* {loading ? <LinearProgress /> : null} */}

        <Button
          variant="contained"
          className={classes.buttonStyle}
          color="primary"
          disabled={loading}
          fullWidth
          onClick={onSubmit}>
          {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default CountryAddEdit;
